import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import './i18n'; // Initialize i18n
import App from './App';
import { BrowserRouter } from "react-router-dom";


import { LoadingProvider } from './contexts/LoadingContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <LoadingProvider>
      <App />
    </LoadingProvider>
  </BrowserRouter>
);
